import Component from 'inferno-component';
import { connect } from 'inferno-redux';
import { getWords } from '../redux/words';
import { sanitizeString } from '../utils';

class DefinitionRow extends Component {
  getSynonym(word) {
    const sanitizedSearchTerm = sanitizeString(word);
    return this.props.getWords(sanitizedSearchTerm).then(searchResults => {
      if (searchResults.length !== 0) {
        const chosenWordId = searchResults[0].id;
        return window.location.replace(
          `${window.location.origin}/definition/${chosenWordId}`
        );
      }
    });
  }

  render() {
    const { definition, index, word } = this.props;
    const synonymClass = definition.syn ? 'definition-row__syn-body' : '';
    return (
      <div className="definition-row__container">
        <div className="definition-row__gutter">
          {definition.def_src &&
            definition.display && (
              <span className="definition-row__word-src">
                {definition.def_src}
              </span>
            )}
        </div>
        <div className={`definition-row__body ${synonymClass}`}>
          {definition.dtxt_num && (
            <span className="definition-row__num">{definition.dtxt_num} </span>
          )}
          {definition.ps && (
            <span className="definition-row__word-class">{definition.ps}</span>
          )}
          {definition.ul && (
            <span className="definition-row__ul">{definition.ul}</span>
          )}
          {definition.props && (
            <span className="definition-row__word-props">
              {definition.props}
            </span>
          )}
          {definition.syn && (
            <span
              onClick={() => this.getSynonym(definition.syn)}
              className="definition-row__syn"
            >
              {definition.syn}{' '}
            </span>
          )}
          {definition.dtxt && (
            <span className="definition-row__definition">
              {definition.dtxt}
            </span>
          )}
          {definition.der && (
            <span className="definition-row__der"> {definition.der}</span>
          )}
          {definition.pollex && (
            <p>
              {definition.pollex.map(pollex => {
                return (
                  <a href={pollex._href} target="_blank">
                    {pollex.__text}
                  </a>
                );
              })}
            </p>
          )}
          {definition.example_txt && (
            <p>
              {definition.example_txt.map(example => {
                return (
                  <span
                    className={`definition-row__example-txt__${example.type}`}
                  >
                    {example.txt}{' '}
                  </span>
                );
              })}
            </p>
          )}
          <div className="definition-row__example">
            {definition.extxt && (
              <span className="definition-row__example-hwn">
                {definition.extxt}&mdash;
              </span>
            )}
            {definition.extran && (
              <span className="definition-row__example-eng">
                {definition.extran}
              </span>
            )}
          </div>
          {definition.addr &&
            definition.addr.map(address => {
              return (
                <p>
                  <a href={address._href} target="_blank">
                    {address.__text}
                  </a>
                </p>
              );
            })}
          {definition.chants &&
            definition.chants.map(chant => {
              const chantPrefix = chant.chtxt ? 'ch' : 'ml';
              return (
                <div className="definition-row__chant">
                  <p className="chant__text">{chant[`${chantPrefix}txt`]}</p>
                  <p className="chant__tran">{chant[`${chantPrefix}tran`]}</p>
                  <p className="chant__src">{chant[`${chantPrefix}src`]}</p>
                </div>
              );
            })}
          {definition.notes && (
            <span className="definition-row__definition">
              {definition.notes}
            </span>
          )}
          {definition.media &&
            definition.media.audio &&
            <div className="definition-row__audio">
              <audio id={`pronunciation-audio-${index}`} src={definition.media.audio} />
              <button type="button" onClick={(e)=> {
                e.stopPropagation();
                const audioExampleNode = document.getElementById(`pronunciation-audio-${index}`);
                return audioExampleNode.paused ? audioExampleNode.play() : audioExampleNode.pause();
              }} />
            </div>
          }
          <div className="definition-row__images">
            {definition.media &&
              definition.media.images &&
              definition.media.images.map(imageSrc => {
              return (
                <img
                  className="definition-row__image"
                  src={imageSrc}
                  alt={word}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => state, { getWords })(DefinitionRow);



// WEBPACK FOOTER //
// ./src/components/DefinitionRow.js